import React from 'react';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { getSubtypeHeader } from '../../../utils/subTypeHeader';

export default function RealEstateForm({ shopType, formState, setFormState }) {
  const subtype = shopType;
  const headerText = getSubtypeHeader(subtype);

  const handleCheckboxChange = (key, value) => {
    setFormState(key, value);
  };

  const handleCheckboxArray = (key, value) => {
    const current = formState[key] || [];
    const updated = current.includes(value)
      ? current.filter(v => v !== value)
      : [...current, value];
    setFormState(key, updated);
  };

  const listingFormats = [
    { label: 'Rent', value: 'Rent' },
    { label: 'Sale', value: 'Sale' },
    { label: 'Management', value: 'Management' }
  ];

  const amenities = ['Wi-Fi', 'Parking', 'Furnished', 'Pool'];

  return (
    <div className="form-section">
      <h3 className="section-title">{headerText}</h3>

      {/* Property Rentals */}
      {subtype === 'RE_rentals' && (
        <>
          <div className="field">
            <label>Listing Format</label>
            <Dropdown
              value={formState[`listingFormat_${subtype}`]}
              options={listingFormats}
              onChange={(e) => setFormState(`listingFormat_${subtype}`, e.value)}
              placeholder="Select Format"
            />
          </div>

          <div className="field">
            <label>Property Type</label>
            <InputText
              value={formState[`propertyType_${subtype}`] || ''}
              onChange={(e) => setFormState(`propertyType_${subtype}`, e.target.value)}
              placeholder="e.g. Apartment, Condo, House"
            />
          </div>

          <div className="field">
            <label className="mr-2">Monthly Rent (₱)</label>
            <InputNumber
              value={formState[`monthlyRent_${subtype}`] || 0}
              onValueChange={(e) => setFormState(`monthlyRent_${subtype}`, e.value)}
              mode="currency"
              currency="PHP"
              locale="en-US"
            />
          </div>

          <div className="field">
            <label>Amenities</label>
            <div className="flex flex-column gap-2">
              {amenities.map(amenity => (
                <div key={amenity} className="flex align-items-center">
                  <Checkbox
                    inputId={`${amenity}_${subtype}`}
                    checked={formState[`amenities_${subtype}`]?.includes(amenity) || false}
                    onChange={() => handleCheckboxArray(`amenities_${subtype}`, amenity)}
                  />
                  <label htmlFor={`${amenity}_${subtype}`} className="ml-2">{amenity}</label>
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {/* Real Estate Agencies */}
      {subtype === 'RE_realEstate' && (
        <>
          <div className="field">
            <label>Service Types</label>
            <InputText
              value={formState[`serviceTypes_${subtype}`] || ''}
              onChange={(e) => setFormState(`serviceTypes_${subtype}`, e.target.value)}
              placeholder="e.g. Property Listing, Buying Assistance"
            />
          </div>

          <div className="field">
            <label>Agent License Number</label>
            <InputText
              value={formState[`agentLicense_${subtype}`] || ''}
              onChange={(e) => setFormState(`agentLicense_${subtype}`, e.target.value)}
              placeholder="e.g. PRC-XXXXX"
            />
          </div>

          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`offersPropertyTours_${subtype}`}
                checked={formState[`offersPropertyTours_${subtype}`] || false}
                onChange={(e) => handleCheckboxChange(`offersPropertyTours_${subtype}`, e.checked)}
              />
              <label htmlFor={`offersPropertyTours_${subtype}`} className="ml-2">Offers Property Tours</label>
            </div>
          </div>
        </>
      )}

      {/* Interior Design */}
      {subtype === 'RE_interiorDesign' && (
        <>
          <div className="field">
            <label>Design Specialties</label>
            <InputText
              value={formState[`designSpecialties_${subtype}`] || ''}
              onChange={(e) => setFormState(`designSpecialties_${subtype}`, e.target.value)}
              placeholder="e.g. Minimalist, Scandinavian, Industrial"
            />
          </div>

          <div className="field">
            <label>Project Range</label>
            <InputText
              value={formState[`projectRange_${subtype}`] || ''}
              onChange={(e) => setFormState(`projectRange_${subtype}`, e.target.value)}
              placeholder="e.g. Studio Units to Full Homes"
            />
          </div>

          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`includes3DRendering_${subtype}`}
                checked={formState[`includes3DRendering_${subtype}`] || false}
                onChange={(e) => handleCheckboxChange(`includes3DRendering_${subtype}`, e.checked)}
              />
              <label htmlFor={`includes3DRendering_${subtype}`} className="ml-2">Includes 3D Rendering</label>
            </div>
          </div>
        </>
      )}

      {/* Home Improvement */}
      {subtype === 'RE_homeImprovement' && (
        <>
          <div className="field">
            <label>Improvement Services</label>
            <InputText
              value={formState[`improvementServices_${subtype}`] || ''}
              onChange={(e) => setFormState(`improvementServices_${subtype}`, e.target.value)}
              placeholder="e.g. Plumbing, Electrical, Painting"
            />
          </div>

          <div className="field">
            <label>Service Area</label>
            <InputText
              value={formState[`serviceArea_${subtype}`] || ''}
              onChange={(e) => setFormState(`serviceArea_${subtype}`, e.target.value)}
              placeholder="e.g. Metro Manila, Laguna, Cavite"
            />
          </div>

          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`emergencySupport_${subtype}`}
                checked={formState[`emergencySupport_${subtype}`] || false}
                onChange={(e) => handleCheckboxChange(`emergencySupport_${subtype}`, e.checked)}
              />
              <label htmlFor={`emergencySupport_${subtype}`} className="ml-2">Offers Emergency Services</label>
            </div>
          </div>
        </>
      )}
    </div>
  );
}